<template>
  <div v-show="getFiltersLength && !typeQueryState" v-if="!isTabletView"
       id="filters-container"
       :class="{
       'q-d-block ': canShowFiltersOnMobile,
       'q-d-none': !canShowFiltersOnMobile,
       'serp__filters--mobile  q-slide-in-left q-position-fixed q-top-0 q-left-0 q-bottom-0 q-right-0 q-w-100 q-h-100 ': canShowFiltersOnMobile && isMobileView
       }"
       class="serp__filters-container q-col-md-4 q-col-lg-3 q-col-sm-12 q-d-lg-block q-py-3 q-py-md-1 q-position-relative q-bg-light">
    <ComponentLoader :loading="isLoading || (productIsLoading && isMobileView)"/>
    <CloseButton v-if="isMobileView"/>
    <FiltersHeaderContainer v-if="isMobileView"/>
    <FiltersListContainer/>
    <div v-if="isMobileView" class="mobile_filters--container q-pt-3 q-border-top">
      <LinearLoader :loading="shouldShowMobileLinearLoader"/>
      <AppendFiltersButton/>
      <ClearFiltersButtonMobile v-if="isMobileView"/>
    </div>


  </div>
</template>

<script setup lang="ts">
import {inject, watch, computed} from "vue";
import FiltersListContainer from '@/components/SerpPage/FiltersContainer/FiltersList/FiltersListContainer.vue'
import FiltersHeaderContainer from '@/components/SerpPage/FiltersContainer/Header/FiltersHeaderContainer.vue'
import CloseButton from "@/components/SerpPage/FiltersContainer/Header/CloseButton.vue";
import AppendFiltersButton from "@/components/SerpPage/ResultsContainer/ButtonsContainer/AppendFiltersButton.vue";
import ComponentLoader from '@/components/ComponentLoader.vue'


import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useMobileViewStore} from "@/store/MobileViewStore";
import {SmartSearchConfigInterface} from "@/core/types";
import {storeToRefs} from "pinia";
import ClearFiltersButtonMobile
  from "@/components/SerpPage/FiltersContainer/ClearFiltersButton/ClearFiltersButtonMobile.vue";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import LinearLoader from "@/components/LinearLoader.vue";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore()
const {canShowFiltersOnMobile, isLoading, getFiltersLength} = storeToRefs(filtersStore)
const {isMobileView, isTabletView} = storeToRefs(mobileViewStore)
const serpStore = useSerpResultsStore();
const {allowEmptyQuery} = SmartSearchConfig.value.serp.query


const {query, loading: productIsLoading} = storeToRefs(serpStore)
const hasLoadedFilters = computed(() => getFiltersLength.value > 0)
const shouldBlockFiltersUi = computed(() => isLoading.value && !hasLoadedFilters.value)
const shouldShowMobileLinearLoader = computed(() => {
  if (!hasLoadedFilters.value) {
    return isLoading.value || (productIsLoading.value && isMobileView.value)
  }

  return productIsLoading.value && isMobileView.value
})
const typeQueryState = computed(() => {
  return !productIsLoading.value && !allowEmptyQuery && !query.value
})
watch(canShowFiltersOnMobile, (newValue) => {
  filtersStore.setBodyScroll(!newValue);
});

</script>

<style scoped>
.serp__filters-container {
  position: relative;
}
#filters-container {
  padding-bottom: 121px!important;
}

.serp__filters--mobile {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  z-index: 9999999 !important;
  background-color: #f8f9fa !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important;
  height: 100vh !important;
  height: 100dvh !important;
  padding-bottom: env(safe-area-inset-bottom);
  padding-top: env(safe-area-inset-top);
}

.mobile_filters--container {
  position: fixed;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  z-index: 9999;
}

</style>
